
export function fitPopupHeight(startHeight: number): number {
  return Math.min(
    startHeight,
    document.documentElement.clientHeight - 75
  );
}

export function fitPopupWidth(startWidth: number): number {
  return Math.min(
    startWidth,
    document.documentElement.clientWidth - 20
  );
}
